
import { Eye, EyeOff, Save, Check, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Toggle } from "@/components/ui/toggle";

interface DashboardControlsProps {
  handlesVisible: boolean;
  toggleHandlesVisibility: () => void;
  saveLayoutToDatabase: () => void;
  resetDashboardLayout: () => void;
  openWidgetsModal: () => void;
  isSaving: boolean;
  savedToDb: boolean;
}

export function DashboardControls({
  handlesVisible,
  toggleHandlesVisibility,
  saveLayoutToDatabase,
  resetDashboardLayout,
  openWidgetsModal,
  isSaving,
  savedToDb
}: DashboardControlsProps) {
  return (
    <div className="flex justify-end mb-4 gap-2">
      <Toggle 
        pressed={handlesVisible}
        onPressedChange={toggleHandlesVisibility}
        aria-label="Toggle handle visibility"
        className="flex items-center gap-1.5"
      >
        {handlesVisible ? (
          <>
            <EyeOff className="h-4 w-4" />
            <span className="text-xs">Deactivate Edit</span>
          </>
        ) : (
          <>
            <Eye className="h-4 w-4" />
            <span className="text-xs">Edit Dashboard</span>
          </>
        )}
      </Toggle>
      
      {handlesVisible && (
        <>
          <Button 
            variant="outline" 
            size="sm"
            onClick={openWidgetsModal}
            className="text-xs flex items-center gap-1.5"
          >
            <Plus className="h-4 w-4" />
            <span>Add Widget</span>
          </Button>
          
          <Button 
            variant="outline" 
            size="sm"
            onClick={saveLayoutToDatabase}
            disabled={isSaving}
            className="text-xs flex items-center gap-1.5"
          >
            {isSaving ? (
              "Saving..."
            ) : savedToDb ? (
              <>
                <Check className="h-4 w-4 text-green-500" />
                <span>Saved</span>
              </>
            ) : (
              <>
                <Save className="h-4 w-4" />
                <span>Save Layout</span>
              </>
            )}
          </Button>
        </>
      )}
      
      <Button 
        variant="outline" 
        size="sm"
        onClick={resetDashboardLayout}
        className="text-xs"
      >
        Reset Layout
      </Button>
    </div>
  );
}
